import { FC, Fragment } from "react";
import { Button } from "@mui/material";
import { DescriptionOutlined } from "@mui/icons-material";
import { InfrastructureArchitectureRecommendationDrawerDocDrawer } from "./InfrastructureArchitectureRecommendationDrawerDocDrawer";
import { useDialog } from "@/utils/hooks/useDialog.hook";

export const InfrastructureArchitectureRecommendationDrawerDoc: FC = () => {
  const { open, openDialog, closeDialog } = useDialog();

  return (
    <Fragment>
      <Button
        size="small"
        color="primary"
        variant="outlined"
        startIcon={<DescriptionOutlined />}
        sx={{
          width: "fit-content",
        }}
        onClick={openDialog}
      >
        Open Documentation
      </Button>

      <InfrastructureArchitectureRecommendationDrawerDocDrawer
        open={open}
        closeDialog={closeDialog}
      />
    </Fragment>
  );
};
